module.exports = {"id":"152908","name":"Ashley Young","rating":"78","photo":"./data/images/photos/3/152908.png","club":{"name":"Manchester Utd","logo":"./data/images/clubs/ManchesterUtd.png"},"positions":["DG","DLG","DD","MG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AshleyYoung0.json
// module id = 489
// module chunks = 0